import React from "react";
import { formatDate } from "../../../../../../Utilities/Functions";
import { Link } from "react-router-dom";
import {
  recordTypes,
} from "../../../../../../API/config";

export const TableHeader = (t) => [
  {
    title: t("labels.audit.table.headers.dateTime"),
    field: "date_time",
    render: (rowData) => {
      return <span>{formatDate(rowData.date_time, true)}</span>;
    },
  },
  {
    title: t("labels.audit.table.headers.performedBy"),
    field: "user_name",
  },
  {
    title: t("labels.audit.table.headers.record"),
    field: "record_name",
    render: (rowData) => {
      if (rowData.record_type === "record") {
        return (
          <Link
            to={`/viewAuditedRecord/basicinfo?id=${rowData.record_id}`}
            target="_blank"
          >
            {rowData.record_name ? rowData.record_name : rowData.record_id}
          </Link>
        );
      } else {
        return (
          <span>
            {rowData.record_name ? rowData.record_name : rowData.record_id}
          </span>
        )
      }
    },
  },
  {
    title: t("labels.audit.table.headers.action"),
    field: "action",
    render: (rowData) => {
      const rt = recordTypes[rowData.record_type] || {};
      const action = (rt.actions || {})[rowData.action];
      return (
        <span>{action ? action.label : rowData.action}</span>
      )
    },
  },
  {
    title: t("labels.audit.table.headers.recordType"),
    field: "record_type",
    render: (rowData) => {
      return (
        <span>{recordTypes[rowData.record_type] ? recordTypes[rowData.record_type].label : rowData.record_type}</span>
      )
    },
  },
];
